import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AdminSidebar.module.scss';
import {
  navigationSlice,
  NavigationSelectors,
  useAppDispatch,
  useAppSelector,
} from '@ax/redux-store';
import { NavigationPages } from '@ax/constants';

interface AdminSidebarItem {
  title: string;
  page: NavigationPages[];
  icon?: string;
}

interface AdminSidebarItemProps {
  item: AdminSidebarItem;
}

const AdminSidebarItem: React.FC<AdminSidebarItemProps> = ({ item }) => {
  const isActive = useAppSelector(NavigationSelectors.selectIsPageActive(item.page));
  const dispatch = useAppDispatch();

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    dispatch(navigationSlice.actions.pageNavigationRequested({ page: item.page }));
  };

  return (
    <Link
      to={'#'}
      className={`${isActive ? styles.active : ''} ${styles.list__item__link}`}
      onClick={handleClick}
    >
      {<span>{item.title}</span>}
    </Link>
  );
};

export default AdminSidebarItem;
